import { useForm } from '@/common/form/FormContext';
import { MenuItem, TextField } from '@mui/material';

// Lets the user choose whether a Property applies to the owning Entity itself or one of its children (e.g. a
// Program Product's Tiers); only editable while adding since the owner shouldn't change afterwards.
export const EntityPropOwnerField = ({ ownerOptions, readOnly }) => {
  const { formValues, assignValue } = useForm();

  const ownerKey = (entity, entityId) => `${entity}:${entityId}`;
  const selectedKey = ownerKey(formValues.entity, formValues.entityId);

  const handleChange = (event) => {
    const option = ownerOptions.find(
      (candidate) => ownerKey(candidate.entity, candidate.entityId) === event.target.value,
    );
    if (!option) return;
    assignValue('entity', option.entity);
    assignValue('entityId', option.entityId);
    // The Props applicable to the new owner may differ; force the user to reselect rather than keep a mismatched Prop
    assignValue('propId', null);
  };

  return (
    <TextField select label="Apply To" value={selectedKey} onChange={handleChange} disabled={readOnly} fullWidth>
      {ownerOptions.map((option) => (
        <MenuItem key={ownerKey(option.entity, option.entityId)} value={ownerKey(option.entity, option.entityId)}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
